/**
 * Store admin — the storefront appearance library (spec 50 story 5).
 *
 * This route used to mount the builder canvas directly. Since spec 50 it lists
 * the store's named appearances instead; the builder moved to
 * `./$appearanceId/index.tsx`.
 */
import { createFileRoute } from "@tanstack/react-router";
import { AppearanceListPage } from "../../../../../features/store/storefront/appearance-list-page.tsx";

export const Route = createFileRoute("/(workspace)/store/admin/storefront/")({
  component: AppearanceListPage,
});
